export const navLinks = [
	{ label: 'Products', href: '/products' },
	{ label: 'Solutions', href: '/solutions' },
	{ label: 'Security', href: '/security' },
	{ label: 'Blog', href: '/blog' },
	{ label: 'Developers', href: 'https://docs.admrl.co', external: true },
	{ label: 'Pricing', href: '/pricing' }
];

export const footerLinks: Record<string, { label: string; href: string; external?: boolean }[]> = {
	Products: [
		{ label: 'Overview', href: '/products' },
		{ label: 'AdmiralOS', href: '/platform' },
		{ label: 'AirDetect', href: '/products/airdetect' },
		{ label: 'How it works', href: '/how-it-works' }
	],
	Solutions: [
		{ label: 'Industrial IoT', href: '/solutions/industrial-iot' },
		{ label: 'Digital Signage', href: '/solutions/digital-signage' },
		{ label: 'Agriculture', href: '/solutions/agriculture' },
		{ label: 'Mining & Utilities', href: '/solutions/mining-utilities' }
	],
	Developers: [
		{ label: 'Documentation', href: 'https://docs.admrl.co', external: true },
		{ label: 'API Reference', href: 'https://docs.admrl.co/api', external: true }
		// { label: 'Status', href: '/status' }
	],
	Company: [
		{ label: 'About', href: '/about' },
		{ label: 'Blog', href: '/blog' },
		{ label: 'Integration Partnership', href: '/integration' },
		{ label: 'Savings Calculator', href: '/pricing/calculator' }
	],
	Legal: [
		{ label: 'Privacy', href: '/privacy' },
		{ label: 'Terms', href: '/terms' },
		{ label: 'Modern Slavery', href: '/modern-slavery' }
	]
};
